import "../css/FooterCss.css";
import lg from "./img/lg.png";
import { PiWhatsappLogo } from "react-icons/pi";
import { FaInstagram } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";

function Footer() {
  return (
    <div className="paiFooter">
      <div className="filhoFooter">
        <div>
          <img className="lg2" src={lg} alt="" />
        </div>
        <ul className="logoRs2">
          <li className="lg3">
            <a href="https://api.whatsapp.com/send?phone=5586994712598&text=Ol%C3%A1,%20gostaria%20de%20fazer%20um%20or%C3%A7amento.">
              <PiWhatsappLogo />
            </a>
          </li>
          <li className="lg3">
            <a href="https://instagram.com/dev_rms?igshid=MzMyNGUyNmU2YQ==">
              {" "}
              <FaInstagram />
            </a>
          </li>
          <li className="lg3">
            <a href="https://www.linkedin.com/in/romenson-cleiton-87834b232?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app">
              {" "}
              <FaLinkedin />
            </a>
          </li>
        </ul>
      </div>
      <hr />
      <div className="rodape">
        <h4 className="txtrodape">
          © Desenvolvimento por Romenson Cleiton - 2024
        </h4>
      </div>
      <br />
    </div>
  );
}

export default Footer;
